import { usePage } from '@inertiajs/react';
import React from 'react';
import { useSearch } from '../../hooks/useSearch';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import UsersHeader from './UsersHeader';
import UsersTable from './UsersTable';

export default function Index() {
  const { props } = usePage();

  // Usar hook de pesquisa para usuários
  const {
    searchTerm,
    setSearchTerm,
    searchInputRef,
    filteredItems: filteredUsers,
    hasSearch,
    totalResults,
    totalItems: totalUsers
  } = useSearch(props.users, ['name', 'email', 'carrier_name']);

  // Função para limpar busca
  const handleClearSearch = () => {
    setSearchTerm('');
  };

  return (
    <DriveSyncLayout>
      <UsersHeader
        showAddButton
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        searchInputRef={searchInputRef}
        placeholder="Pesquisar..."
        totalResults={totalResults}
        totalUsers={totalUsers}
        hasSearch={hasSearch}
        onClearSearch={handleClearSearch}
      />
      <UsersTable users={filteredUsers} />
    </DriveSyncLayout>
  );
} 